import React from 'react';
import { Badge } from '../ui/Badge';
import { WorkerAnagrafica } from '../../types/worker';
interface WorkerDetailHeaderProps {
  worker: WorkerAnagrafica;
}
export function WorkerDetailHeader({
  worker
}: WorkerDetailHeaderProps) {
  const trainingOk = worker.trainingStatus === 'valid' || worker.trainingStatus === 'In regola';
  const trainingExpiring = worker.trainingStatus === 'expiring' || worker.trainingStatus === 'In scadenza';
  const healthOk = worker.healthStatus === 'fit' || worker.healthStatus === 'Idoneo';
  return <div className="flex items-start gap-4 mb-6" data-id="element-2205" data-mp="173ldx87pqqse">
      <div data-id="element-2206" data-mp="1ktorlasj1c68">
        <h2 className="text-2xl font-bold text-seform-navy" data-id="element-2207" data-mp="1ku6z53kn3ctg">{worker.name}</h2>
        <p className="text-slate-500" data-id="element-2208" data-mp="1g1x2z5sxlgiq">
          {worker.role} presso{' '}
          <span className="font-semibold text-seform-orange" data-id="element-2209" data-mp="1g0m1jcmykkus">
            {worker.company}
          </span>
        </p>
        <div className="flex gap-2 mt-2" data-id="element-2210" data-mp="obiwvvr5t8hm">
          <Badge variant={trainingOk ? 'success' : trainingExpiring ? 'warning' : 'danger'} data-id="element-2211" data-mp="oar9h87puh2f">
            Formazione:{' '}
            {trainingOk ? 'OK' : trainingExpiring ? 'In scadenza' : 'Scaduta'}
          </Badge>
          <Badge variant={healthOk ? 'success' : 'danger'} data-id="element-2212" data-mp="2hd6l97wsbfpx">
            Visita: {healthOk ? 'Idoneo' : 'Non idoneo'}
          </Badge>
        </div>
      </div>
    </div>;
}